"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Random = void 0;
const core_1 = require("flow-connect/core");
const utils_1 = require("flow-connect/utils");
const ui_1 = require("flow-connect/ui");
class Random extends core_1.Node {
    constructor() {
        super();
    }
    setupIO() {
        this.addTerminals([
            { type: core_1.TerminalType.IN, name: "trigger", dataType: "event" },
            { type: core_1.TerminalType.OUT, name: "value", dataType: "number" },
        ]);
    }
    created(options) {
        const { width = 150, name = "Random", style = {}, state = {} } = options;
        this.width = width;
        this.name = name;
        this.state = Object.assign(Object.assign({}, Random.DefaultState), state);
        this.style = Object.assign({ rowHeight: 10 }, style);
        this.setupUI();
        this.setupListeners();
    }
    process() {
        let random;
        if (this.state.fractional)
            random = (0, utils_1.getRandom)(this.state.min, this.state.max);
        else
            random = Math.floor((0, utils_1.getRandom)(Math.floor(this.state.min), Math.floor(this.state.max)));
        this.setOutputs(0, random);
    }
    setupUI() {
        this.minInput = this.createUI("core/input", {
            propName: "min",
            input: true,
            output: true,
            height: 20,
            style: { type: ui_1.InputType.Number, grow: 1, step: "any" },
        });
        this.maxInput = this.createUI("core/input", {
            propName: "max",
            input: true,
            output: true,
            height: 20,
            style: { type: ui_1.InputType.Number, grow: 1, step: "any" },
        });
        this.fractionalToggle = this.createUI("core/toggle", {
            propName: "fractional",
            input: true,
            output: true,
            height: 10,
            style: { grow: 0.2 },
        });
        this.ui.append([
            this.createUI("core/x-layout", {
                childs: [this.createUI("core/label", { text: "Min:", style: { grow: 0.3 } }), this.minInput],
                style: { spacing: 20 },
            }),
            this.createUI("core/x-layout", {
                childs: [this.createUI("core/label", { text: "Max:", style: { grow: 0.3 } }), this.maxInput],
                style: { spacing: 20 },
            }),
            this.createUI("core/x-layout", {
                childs: [this.createUI("core/label", { text: "Fractional ?", style: { grow: 0.8 } }), this.fractionalToggle],
                style: { spacing: 10 },
            }),
        ]);
    }
    setupListeners() {
        this.watch("min", () => this.process());
        this.watch("max", () => this.process());
        this.watch("fractional", () => this.process());
        this.inputs[0].on("event", () => this.process());
    }
}
exports.Random = Random;
Random.DefaultState = { min: 0, max: 100, fractional: false };
